import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const RenewalSimReportModule = new Module({
  id: 'renewal-sims-report',
  name: 'Renewal Sims Report',
  path: 'renewal-of-sims',
  Component: ComponentLoader(
    lazy(() => import('src/content/Report/RenewalReport/View'))
  ),
});

const RenewalSimReportModules = [RenewalSimReportModule];

export default new ModuleBundle('ExpirySimReport', RenewalSimReportModules);
